(() => {
    'use strict';

    angular
        .module('uwAgenda.users')
        .controller('TranscriptController', [
            '$uibModalInstance',
            'transcript',
            TranscriptControllerFn]);

    function TranscriptControllerFn(
        $uibModalInstance,
        transcript) {
        let viewModel = this;
        
        viewModel.transcript = transcript;

        let data;
        try {
          data = JSON.parse(transcript.content);
        } catch (e) {
          console.log('error parsing transcription:', e);
          data = transcript.content;
        }

        viewModel.transcriptionData = data;
        
        viewModel.no = () => {
            $uibModalInstance.dismiss();
        };
    }
})();
